import React, { useEffect, useState } from 'react'
import {ReactComponent as Bank} from '../../../assets/new-icons/bank2.svg';
import {ReactComponent as Card} from '../../../assets/new-icons/card.svg';
import ConfermaBTN from '../../../components/ConfermaBTN/ConfermaBTN';
import { useSelector } from 'react-redux';
import md5 from 'md5';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setMetodoAggiunto, setPath } from '../../../features/settingSlice';

function Step5(props) {
    const dispatch = useDispatch()
    const location = useLocation()
    const [disabled, setDisabled] = useState(true)
    const customerId = useSelector((user) => user.user.info.customer_id)
    const customerIdGas = useSelector((user) => user?.gas?.info?.customer_id)
    const section = useSelector((user) => user.settings.section)
    const pod = useSelector((user) => user.user.currentPod.podCode)
    const tkn = md5(customerId + 'oYmAIdtki%lu') 
    const tknGas = md5(`${customerIdGas}oYmAIdtki%lu`)
    const urlCard = `https://my.revoluce.it/area_utente/gestione/api/customers/saveCard.php?name=${props.name}&number=${props.number}&expiry_month=${props.month}&expiry_year=${props.year}&cvv=${props.cvv}&customer_id=${customerId}&tkn_pvt=${tkn}`            
    const urlGasCard = `https://my.revoluce.it/area_utente/gestione/api/customers/saveCard.php?name=${props.name}&number=${props.number}&expiry_month=${props.month}&expiry_year=${props.year}&cvv=${props.cvv}&customer_id=${customerIdGas}&tkn_pvt=${tknGas}`            
    const urlIban = `https://my.revoluce.it/area_utente/gestione/api/faidate/aggiungiIban.php?customer_id=${customerId}&tkn_pvt=${tkn}&nome=${props.name}&codice_fiscale=${props.month}&iban=${props.number}&codice_pod=${pod}`
    const urlGasIban = `https://my.revoluce.it/area_utente/gestione/api/faidate/aggiungiIban.php?customer_id=${customerIdGas}&tkn_pvt=${tknGas}&nome=${props.name}&codice_fiscale=${props.month}&iban=${props.number}&codice_pod=${pod}`

    const nextStep = () => {
        props.setStep(props.step + 1)
    }
    useEffect(() => {
        init()
    },[])

    const init = () => {
        dispatch(setPath(location.pathname))
        dispatch(setMetodoAggiunto(props.idMethod))
    }
    return (
        <div className='step1'>
            {props.idMethod === 1 ? (
                <>
                    <div className="cardRecap">
                        <div className="headerCard">
                            <div className="type">
                                <Card />
                                <p>Carta di credito</p>
                            </div>
                           <div className="numberCard">
                               <p>{props.number && props.number.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()}</p>
                           </div>
                        </div>
                        <div className="middleCard">
                            <p className='secondary'>Intestatario</p>
                            <p className='primary'>{props.name && props.name}</p>
                        </div>
                        <div className="footerCard">
                            <div className="expiry">
                                <p className="secondary">Data di scadenza</p>
                                <p className="primary">{props.month} / {props.year}</p>
                            </div>
                            <div className="cvv">
                                <p className="secondary">Codice di controllo</p>
                                <p className="primary">{props.cvv && props.cvv}</p>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="cardRecap">
                        <div className="headerCard">
                            <div className="type">
                                <Bank />
                                <p className='secondary'>Conto corrente</p>
                            </div>
                        </div>
                        <div className="middleCard">
                            <p className='secondary'>Intestatario</p>
                            <p className='primary'>{props.name && props.name}</p>
                        </div>
                        <div className="middleCard">
                            <div className="expiry">
                                <p className="secondary">Iban:</p>
                                <p className="primary">{props.number && props.number}</p>
                            </div>
                        </div>
                        <div className="footerCard">
                            <div className="expiry">
                                <p className="secondary">Codice fiscale:</p>
                                <p className="primary">{props.month && props.month}</p>
                            </div>
                        </div>
                        <p className='main'></p>
                    </div>
                    <div className="text">
                        <p className="secondary">Ti ricordiamo che troverai la nuova modalità di pagamento disponibile entro 5 giorni lavorativi.</p>
                        <p className="secondary">
                            <span className="bold">Attenzione:</span>
                            non è possibile modificare la modalità di pagamento per richieste già inviate.
                        </p>
                    </div>
                </>
            )}
            {
                props.idMethod === 1 ? (
                    <ConfermaBTN 
                        text="Conferma metodo" 
                        confermTxt={`Confermi di voler aggiungere il nuovo metodo di pagamento: ${props.number}?`}
                        forward="/enrica/richiesta-inoltrata"
                        url={section ? urlGasCard : urlCard}
                    />
                ) : (
                    <ConfermaBTN 
                        text="Conferma metodo" 
                        confermTxt={`Confermi di voler aggiungere il nuovo metodo di pagamento: ${props.number}?`}
                        forward="/enrica/richiesta-inoltrata"
                        url={section ? urlGasIban : urlIban}
                    />
                )
            }
            
             {/* <SwiperButton name={props.name} number={props.number} month={props.month} year={props.year} cvv={props.cvv} method={props.idMethod} /> */}
        </div>
    )
}

export default Step5
